import { render, staticRenderFns } from "./CustomerGroupProperty.vue?vue&type=template&id=3cd31d52"
import script from "./CustomerGroupProperty.vue?vue&type=script&lang=ts"
export * from "./CustomerGroupProperty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports